export const statusOptions = [
  { label: 'Online', value: 'online', color: 'green', humor: 'Ready to chat!' },
  { label: 'Away', value: 'away', color: 'yellow', humor: 'BRB!' },
  { label: 'Do Not Disturb', value: 'do not disturb', color: 'purple', humor: 'Shhh!' },
  { label: 'Invisible', value: 'invisible', color: 'gray', humor: 'Now you see me, now you don’t!' },
];
